// components/MaintenanceIcon.tsx
import React from "react";

interface MaintenanceIconProps extends React.SVGProps<SVGSVGElement> {
    size?: number;
    color?: string;
}

const MaintenanceIcon: React.FC<MaintenanceIconProps> = ({
    size = 26,
    color = "black",
    ...props
}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M1.313 0L0 1.313L2.313 5.313L3.813 5.093L12.969 14.25L12.188 15C11.788 15.4 11.788 16.006 12.188 16.406L12.594 16.813C12.994 17.213 13.606 17.213 13.906 16.813L15.094 18C14.994 18.6 15.094 19.313 15.594 19.813L21 25.188C22.1 26.288 23.9 26.288 25 25.188C26.3 23.988 26.288 22.194 25.188 21.094L19.813 15.687C19.313 15.187 18.6 14.987 18 15.187L16.687 14C16.987 13.6 16.987 12.988 16.687 12.687L16.312 12.313C16.2211 12.2182 16.112 12.1428 15.9911 12.0912C15.8703 12.0397 15.7403 12.0131 15.609 12.0131C15.4777 12.0131 15.3477 12.0397 15.2269 12.0912C15.106 12.1428 14.9969 12.2182 14.906 12.313L14.25 12.969L5.094 3.813L5.312 2.313L1.313 0ZM20.813 0.031C18.84 -0.133 16.224 1.175 15 2.312C13.494 3.818 13.74 5.787 14.937 7.688L12.813 9.813L14.313 11.5C15.113 10.8 16.293 10.8 17.093 11.5L17.5 11.906L17.594 12L18.469 11.125C20.277 12.188 22.159 12.341 23.594 10.906C24.994 9.606 26.512 6.4 25.812 4.5L23 7.406C22.6 7.806 21.994 7.806 21.594 7.406L18.687 4.5C18.5922 4.40909 18.5168 4.29995 18.4652 4.17914C18.4137 4.05833 18.3871 3.92834 18.3871 3.797C18.3871 3.66566 18.4137 3.53567 18.4652 3.41486C18.5168 3.29405 18.5922 3.18491 18.687 3.094L21.595 0.188C21.345 0.1 21.095 0.055 20.813 0.031ZM9.813 12.5L6.187 16.125C5.7973 16.0388 5.39911 15.9968 5 16C2.2 16 0 18.2 0 21C0 23.8 2.2 26 5 26C7.8 26 10 23.8 10 21C10 20.487 9.919 19.994 9.781 19.531L11.906 17.406L11.594 17C10.794 16.2 10.8 14.988 11.5 14.187L9.813 12.5ZM17.563 17.063C17.688 17.063 17.806 17.087 17.906 17.188L23.813 23.094C24.013 23.294 24.013 23.612 23.813 23.812C23.613 24.012 23.293 24.012 23.093 23.812L17.188 17.906C16.988 17.706 16.988 17.388 17.188 17.188C17.288 17.088 17.438 17.063 17.563 17.063ZM5.688 18.405L7.594 20.312L6.906 22.905L4.313 23.593L2.406 21.686L3.094 19.093L5.688 18.405Z"
                fill={color}
            />
        </svg>
    );
};

export default MaintenanceIcon;
